module.exports = __webpack_public_path__ + "img/webclip.7943e817.png";